import { HTMLAttributes, PropsWithChildren } from "react";

import { css } from "@compiled/react";

export type TabPanelProps = PropsWithChildren<{
    isActive?: boolean;
}> &
    HTMLAttributes<HTMLDivElement>;

const hiddenStyles = css({
    display: "none"
});

export const TabPanel = ({
    children,
    id,
    isActive = true,
    ...rest
}: TabPanelProps) => {
    return (
        <div
            css={!isActive && hiddenStyles}
            id={id}
            role="tabpanel"
            aria-labelledby={`tab-${id}`}
            tabIndex={0}
            hidden={!isActive}
            {...rest}
        >
            {children}
        </div>
    );
};
